module.exports = __webpack_public_path__ + "img/87775d5.png";